import React, { useEffect, useState } from "react";
import Sidebar from "../includes/sidebar.js"
import { Link, Navigate } from "react-router-dom";
import "../style/app.css"
import { useSelector } from "react-redux";
import { Token } from "../redux/selectors/selector.js";
import Toro from "../assets/image/toro1.svg"
import Toro1 from "../assets/image/toro.svg"
import Chat from "../chat/index.js";
import { InvestmentResearchModal } from "../utils/common.js";

const PrivateRoute = ({ Component }) => {

  const [chatOpen, setChatOpen] = useState(false)

  // const Authtoken = useSelector(Token)  
  const [isHovered, setIsHovered] = useState(false);
  const [isModalActive, setModalActive] = useState(false);
  const auth = localStorage.getItem('Token')
  const openNotificationModal = () => {
    console.log("Opening notification modal...");
  };

  const openModal = () => {
    setModalActive(true);
  };

  const closeModal = () => {
    setModalActive(false);
  };

   useEffect(() => {
    // Function to check and update body overflow
    const updateBodyOverflow = () => {
      const modalActive = document.querySelector(".modal.active");
      if (modalActive) {
        document.body.style.overflow = "hidden"; // Prevent scrolling
      } else {
        document.body.style.overflow = "auto"; // Restore scrolling
      }
    };

    // Create a MutationObserver to watch for changes in the DOM
    const observer = new MutationObserver(updateBodyOverflow);

    // Observe changes in the entire document body
    observer.observe(document.body, {
      childList: true, // Detect new elements
      subtree: true, // Observe all child elements
      attributes: true, // Detect attribute changes (e.g., class changes)
      attributeFilter: ["class"], // Watch only class changes
    });

    // Initial check
    updateBodyOverflow();

    // Cleanup observer on unmount
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const updateBodyOverflow = () => {
      const modalActive = document.querySelector(".modal.active");
      const sidebarActive = document.querySelector(".sidebar-active .sidebar");
      if (modalActive || sidebarActive) {
        document.body.style.overflow = "hidden"; 
      } else {
        document.body.style.overflow = "auto"; 
      }
    };

    // Create a MutationObserver to watch for changes in the DOM
    const observer = new MutationObserver(updateBodyOverflow);

    // Observe changes in the entire document body
    observer.observe(document.body, {
      childList: true, 
      subtree: true,
      attributes: true, 
      attributeFilter: ["class"], 
    });

    // Initial check
    updateBodyOverflow();

    // Cleanup observer on unmount
    return () => observer.disconnect();
  }, []);


  // if (!Authtoken && window.localStorage.getItem('Token')) {
  //   return "Loading....";
  // }
  return auth ?
    <>
      <div className="PrivateRoute">
        <Sidebar openNotificationModal={openNotificationModal} />
        <div className='page-content'>
          <Component />
          {/* <div className="toro-container"><a href="https://chatgpt.com/g/g-dHiY9dhkA-rally-bulls"><img src={Toro} alt="toro" /></a></div> */}

        
          <InvestmentResearchModal
            isActive={isModalActive}
            onClose={closeModal}
          />
        </div>
      </div>
    </>
    : <Navigate to="/" />
}

export default PrivateRoute;


// ---------  ToroAI - Investment Research Button Fixed 
// <div
// className="toro-container"
// onMouseEnter={() => setIsHovered(true)}
// onMouseLeave={() => setIsHovered(false)}
// >
// {chatOpen && <Chat chatOpen={chatOpen} setChatOpen={setChatOpen} />}
// {/* <Chat /> */}
// <div onClick={() => { setChatOpen(!chatOpen) }}>
//   {/* href="https://chatgpt.com/g/g-dHiY9dhkA-rally-bulls" */}
//   <img
//     src={isHovered ? Toro : Toro1}
//     alt="toro"
//     className={isHovered ? 'zoom' : 'zoom'}
//   />
// </div>
// </div>
// <div
// className="investment-research-container"
// >

// <div className="cta-wrap">
//   <div onClick={()=> openModal()}
//   // to="/home/marketPreview" 
//   className="cta-btn cta-fill-IR cursor-pointer" style={{ padding: "9px 10px" }}>
//     Investment Research
//   </div>
// </div>
// </div>
